<template>
  <div class="shop-plans-acknowledge">
    <div class="component-background" @click="close" />
    <div class="wrapper">
      <button class="delete is-large is-pulled-right" @click="close" />
      <div class="subtitle is-size-4" @click="close">
        Welcome to
        <img :src="tukWord" />
      </div>
      <p class="subtitle is-size-5">We look forward to working with you!</p>

      <p class="question">What's the name of your shop?</p>
      <div class="field">
        <p class="control has-icons-left">
          <input
            class="input is-medium"
            v-model="shopName"
            type="text"
            placeholder="Shop Name"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-store-alt" />
          </span>
        </p>
      </div>

      <p class="question">What's your mobile phone number?</p>
      <div class="field">
        <p class="control has-icons-left">
          <input
            class="input is-medium"
            v-model="phoneNumber"
            type="text"
            placeholder="Phone Number"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-mobile-alt" />
          </span>
        </p>
      </div>

      <p class="question">What's your business email?</p>
      <div class="field">
        <p class="control has-icons-left">
          <input
            class="input is-medium"
            v-model="email"
            type="text"
            placeholder="Email"
          />
          <span class="icon is-small is-left">
            <i class="far fa-envelope" />
          </span>
        </p>
      </div>

      <div style="margin-top: 30px">
        <p style="font-size: 0.9em">
          By using TUK you agree to the
          <span class="link" @click="gotoTermsAndConditions"
            >Terms and Conditions</span
          >.
        </p>
        <p style="padding: 6px 0">
          <span
            class="button is-medium has-text-info is-fullwidth"
            @click="submit"
          >
            Get started!
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus.js";

export default {
  name: "ShopPlansAcknowledge",
  components: {},
  data() {
    return {
      shopName: null,
      phoneNumber: null,
      email: null,
      tukWord: require("../../public/img/icons/transparent-dark-180x180.png"),
    };
  },
  computed: {
    valid() {
      if (!this.shopName || this.shopName.length < 3) return false;
      if (!this.phoneNumber || this.phoneNumber.length < 8) return false;
      return true;
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    gotoTermsAndConditions() {
      var url = `https://tuk-website.sgp1.digitaloceanspaces.com/Tuk%20Terms%20of%20Service.pdf`;
      window.open(url, "_target");
    },
    submit() {
      if (!this.valid) {
        var errMsg = `Enter your shop name<br>and phone number`;
        this.warningToast(errMsg, "top", 9000);
        return;
      }
      this.log("shop_plans_acknowledged", this.$data);
      var notification = `💈 Shop plans acknowledged by ${this.shopName} 📱 ${this.phoneNumber} 📧 ${this.email}`;
      this.sendSuperuserNotification(notification);
      this.sendEmail();
      this.successModal();
      this.close();
    },
    sendEmail() {
      var obj = {
        topic: "shop_plans_acknowledged",
        type: "shop_plans_acknowledged",
        user_id: this.$store.getters.getUserID, //this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        phone_number: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        shop_name: this.shopName,
        shop_phone: this.phoneNumber,
        shop_email: this.email,
        app: process.env.VUE_APP_TITLE,
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
    },
    successModal() {
      this.$swal({
        title: "You're All Set!",
        text: "TUK Support will reach out to you to help you start setting up your shop within the next 3 business days.",
        type: "success",
        animation: true,
      }).then((val) => {
        if (val.value) {
          this.goHome();
        }
      });
    },
  },
};
</script>

<style scoped>
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  position: absolute;
  bottom: 0px;
  width: 100vw;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 18px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 5;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  text-align: left;
  max-width: 700px;
  right: 0;
}
.delete {
  position: absolute;
  right: 0;
  top: 0;
  margin: 10px;
  padding: 10px;
  color: rgba(17, 34, 51, 0.6);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
p {
  margin-bottom: 10px;
}
.question {
  font-weight: 500;
  padding-top: 6px;
}
.button {
  font-weight: 500;
}
img {
  display: inline-block;
  height: 70px;
  margin-top: -28px;
  margin-bottom: -24px;
  margin-left: -10px;
}
</style>